"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var features_1 = require("../../../../../common/constants/features");
exports.useCarOptions = function (car) {
    var isFromAltSpc = core_1.useTheme().checkoutLite.isFromAltSpc;
    var _a = react_1.useState([]), carOptions = _a[0], setCarOptions = _a[1];
    react_1.useEffect(function () {
        var _a;
        if (isFromAltSpc) {
            var carOptions_1 = (_a = car.selectedFeatures) === null || _a === void 0 ? void 0 : _a.filter(function (option) { return !option.code.includes(features_1.FEATURES.BACKGROUND) && !option.code.includes(features_1.FEATURES.ROOF); });
            setCarOptions(carOptions_1);
        }
        else {
            setCarOptions(car.selectedFeatures);
        }
    }, [car]);
    return carOptions;
};
